<template>
  <!-- https://buefy.org/documentation/field#addons -->
  <b-field class="form_field_filter">
    <p v-if="label" class="control">
      <span class="button is-skinny is-small is-static">{{ label }}</span>
    </p>
    <!-- https://buefy.org/documentation/select  -->
    <b-select
      v-bind="$attrs"
      :value="value"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      size="is-small"
      expanded
    >
      <slot></slot>
    </b-select>
  </b-field>

</template>

<script>
  import FormField from "../../form/FormField";
  import {FormFieldMixin} from "../../form/FormField.mixin";

  export default {
    name: "FilterFieldDefault",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {
        type: [String, Number, Boolean, Date],
      },
      label: {
        type: String
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
// see form.scss
</style>
